<div class="filters">

  <div class="filters__name">{{ 'INTERFACE|Filtry' | translate }}</div>

  <div *ngIf="!isOrderList" class="filters__filter">

    <div class="filters__filter__name" *ngIf="!isInquiryList && !isServiceOrderList">{{ 'SALES_DOCUMENT|Nr oferty' | translate }}</div>
    <div class="filters__filter__name" *ngIf="isInquiryList">{{ 'SALES_DOCUMENT|Nr zapytania ofertowego' | translate }}</div>
    <div class="filters__filter__name" *ngIf="isServiceOrderList ">{{ 'SALES_DOCUMENT|Nr zamówienia' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <icc-input
            type="text"
            name="nrOffer"
            [value]="nrOffer"
            (valueChange)="nrOffer = $event"
        ></icc-input>
      </icc-form-field>

    </div>

  </div>

  <div *ngIf="isOrderList" class="filters__filter">

    <div class="filters__filter__name">{{ 'SALES_DOCUMENT|Nr zamówienia' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <icc-input
            type="text"
            name="nrOrder"
            [value]="nrOrder"
            (valueChange)="nrOrder = $event"
        ></icc-input>
      </icc-form-field>

    </div>

  </div>

  <div class="filters__filter" *ngIf="!isServiceOrderList">

    <div class="filters__filter__name">{{ 'SALES_DOCUMENT|Własny kod oferty / zamówienia' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <icc-input
            type="text"
            name="documentCode"
            [value]="documentCode"
            (valueChange)="documentCode = $event"
        ></icc-input>
      </icc-form-field>

    </div>

  </div>

  <div *ngIf="!isOrderList && showDocumentStatuses" class="filters__filter">

    <div class="filters__filter__name">{{ 'SALES_DOCUMENT|Status' | translate }}</div>

    <div class="row" >

      <icc-form-field
          size="small"
        >
          <icc-select
              type="text"
              name="status"
              [value]="status"
              (valueChange)="handleStatus($event)"

          >
            <option [value]="null">
                {{ 'INTERFACE|Wszystkie' | translate }}
            </option>
            <option [value]="el.id" *ngFor="let el of documentStatuses">
                {{ el.name }}
              </option>
          </icc-select>

        </icc-form-field>

    </div>

  </div>

  <div *ngIf="!isOrderList" class="filters__filter">

    <div class="filters__filter__name" *ngIf="!isInquiryList && !isServiceOrderList">{{ 'SALES_DOCUMENT|Data utworzenia oferty' | translate }}</div>
    <div class="filters__filter__name" *ngIf="isInquiryList">{{ 'SALES_DOCUMENT|Data utworzenia zapytania ofertowego' | translate }}</div>
    <div class="filters__filter__name" *ngIf="isServiceOrderList ">{{ 'SALES_DOCUMENT|Data utworzenia zamówienia' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <label iccLabel>{{ 'INTERFACE|Od' | translate }}</label>
        <icc-input
            type="date"
            name="date"
            [value]="creationDateFrom"
            (valueChange)="creationDateFrom =$event"
        >
        </icc-input>
      </icc-form-field>

    </div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <label iccLabel>{{ 'INTERFACE|Do' | translate }}</label>
        <icc-input
            type="date"
            [value]="creationDateTo"
            (valueChange)="creationDateTo = $event"

        >
        </icc-input>

      </icc-form-field>

    </div>

  </div>


  <div *ngIf="!isOrderList && !isServiceOrderList" class="filters__filter">

    <div class="filters__filter__name" *ngIf="!isInquiryList">{{ 'SALES_DOCUMENT|Data ważności oferty' | translate }}</div>
    <div class="filters__filter__name" *ngIf="isInquiryList">{{ 'SALES_DOCUMENT|Data ważności zapytania ofertowego' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <label iccLabel>{{ 'INTERFACE|Od' | translate }}</label>
        <icc-input
            type="date"
            [value]="validityDateFrom"
            (valueChange)="validityDateFrom = $event"

        >
        </icc-input>

      </icc-form-field>

    </div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <label iccLabel>{{ 'INTERFACE|Do' | translate }}</label>
        <icc-input
            type="date"
            [value]="validityDateTo"
            (valueChange)="validityDateTo = $event"

        >
        </icc-input>

      </icc-form-field>

    </div>

  </div>

  <div class="filters__filter" *ngIf="side === 'sales'">

    <div class="filters__filter__name">{{ 'SALES_DOCUMENT|Klient' | translate }}</div>

    <div class="row" >

      <icc-form-field
        size="small"
      >
        <icc-input
            type="text"
            name="client"
            [value]="client"
            (valueChange)="client = $event"
        ></icc-input>
      </icc-form-field>

    </div>

  </div>

  <div
    *ngIf="workersList && !isServiceOrderList"
    class="filters__filter"
  >

    <div class="filters__filter__name">{{ 'COMPANY|Pracownicy' | translate }}</div>
    <div class="row" >

      <icc-form-field
          size="small"
        >
          <icc-select
              type="text"
              name="authorUserId"
              [value]="authorUserId"
              (valueChange)="handleWorkers($event)"

          >
            <option [value]="null">
              {{ 'INTERFACE|Wszyscy' | translate }}
            </option>
            <option
                *ngFor="let worker of workersList | keyvalue"
                value="{{worker.key}}"
              >
                {{worker.value}}
            </option>
          </icc-select>

        </icc-form-field>

    </div>

  </div>

  <div class="filters__actions">
    <div class="row">
        <button iccButton appearance="secondary" (click)="emitFilters()">
            {{ 'INTERFACE|Filtruj' | translate }} <icc-icon name="navigate_next"></icc-icon>
        </button>
    </div>

    <div class="row">
        <button iccButton appearance="outline" (click)="resetFilters()">
            {{ 'INTERFACE|Resetuj' | translate }}  <icc-icon name="navigate_before"></icc-icon>
        </button>
    </div>
  </div>

</div>
